import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/CSS/Master.css";
import "./assets/CSS/Template.css";
import "./assets/CSS/App.css";
import "./assets/CSS/M/Master.css";

createApp(App).use(router).mount("#app");